/** "Used by meeting transcription, voice notes and 2 agents", or "Not used" (AIT-118): a tool at work never reads as idle. */
export function usedByLine(platform: string[], agents: number): string {
  const uses = [...platform, ...(agents ? [`${agents} agent${agents === 1 ? "" : "s"}`] : [])];
  const last = uses.pop();
  return last ? `Used by ${uses.length ? `${uses.join(", ")} and ` : ""}${last}` : "Not used";
}
